import { gql } from '@apollo/client';

export const GET_CUSTOMER = gql`
  query readAppCustomer {
    readAppCustomer {
      uid
      accountType
      azureId
      customerNumber
      aimoPlusSubscriber
      firstName
      lastName
      megaflex {
        tokens {
          name
          code
          active
          type
          serialNumber
        }
      }
      strongAuthentication {
        gedi
        vendor
        addresses {
          streetNumber
          streetName
          postalCode
          city
          countryCode
        }
        validDriversLicense
        authenticationDone
        addressUpdated
      }
      mobilePhone
      contactEmail
      invoiceEmail
      customerType
      customerSubTypes
      countryCode
      vehicles {
        licensePlate {
          plateText
          countryCode
        }
        cameraRecognition {
          allowed
          enabled
          countryCodes
        }
        appSettings {
          icon
          color
          type
          evPlugType
        }
        name
        id
      }
      paymentCards {
        cardId
        expireDateMMYY
        expireDate
        maskedPan
        expMonth
        expYear
        countryCode
        isDefault
        paymentProvider
        paymentMethod
        type
        status
        created
        lastNums
        category
        description
      }
      paymentOptions {
        optionId
        method
        name
        includedCountries
        serviceChannel
        isDefault
        isDefaultTokenizedPaymentOption
        validity {
          validFrom
          validTo
        }
        registrationPlates {
          plateText
          countryCode
        }
      }
      acceptances {
        type
        countryCode
        accepted
      }
      unlockedCustomerSegments {
        customerSegmentUid
        zoneCode
        expiration
        countryCode
      }
      subsidiary
      serviceChannels {
        code
        status
      }
      language
      preferredLanguage
      applicationPreferences {
        sendEmailReceipts
        alwaysSelectVehicle
      }
      customerNumber
      licensePlateBasedPermits {
        id
        orderLineIdWithVersion
        parkingZoneUid
        accessToCustomerSegmentUid
        lowEmissionPermit
        registrationPlates {
          plateText
        }
        salesLocationUid
        salesLocation {
          uid
          name
          parkingZones
          description
        }
      }
    }
  }
`;
